import { render, staticRenderFns } from "./viewNotification.vue?vue&type=template&id=71959647"
import script from "./viewNotification.vue?vue&type=script&lang=js"
export * from "./viewNotification.vue?vue&type=script&lang=js"
import style0 from "./viewNotification.vue?vue&type=style&index=0&id=71959647&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports